import { render, staticRenderFns } from "./filtermenu.vue?vue&type=template&id=3205353e&"
import script from "./filtermenu.vue?vue&type=script&lang=js&"
export * from "./filtermenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports